import React from 'react'
import styles from "./LoaderPage.module.css"
import { Box } from '@primer/react'
import { useAuth } from '../../hooks/useAuth';
export const LoaderPage = () => {
    const { user } = useAuth();
    const logoUrl = user?.vender_logo ?? 'https://auth.1school.edu.vn/logo.png'
    return (
        <>
            <div style={{
                height: window.innerHeight - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                <Box className={styles.logoContainer}>
                    <img alt='logo' className={styles.logo} style={{ height: "60px" }} src={`${logoUrl}`} />
                    {/* <div className={styles.lightOverlay}></div> */}
                    <Box className={styles.loadingDots} sx={{
                        m: 3
                    }}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </Box>

                </Box>

            </div>
        </>
    )
}

export default LoaderPage